import { render_layout } from './layouts'
import { router_base } from './base'
import { router_client } from './client'
import { router_seller } from './seller'
import { router_coordination } from './coordination'
import { router_construccion } from './construccion'
import { router_hostspot } from './hostspot'
import { createRouter, createWebHistory } from 'vue-router';
// import { fetchProfileData } from '../plugins/layouts_utils'

const my_routes = [
  ...router_base,
  ...router_client,
  ...router_seller,
  ...router_coordination,
  ...router_construccion,
  ...router_hostspot
];
function obtenerClavesLocalStorage() {
  const claves = [];
  for (let i = 0; i < localStorage.length; i++) {
    claves.push(localStorage.key(i), localStorage.getItem(i));
  }
  return claves;
}
const router = createRouter({
  history: createWebHistory(),
  routes: my_routes,
  scrollBehavior(to, from, savedPosition) {
    if (to.hash) {
      return {
        el: to.hash,
        behavior: 'smooth',
      };
    }
    return {
      left: 0,
      top: 0,
      behavior: 'smooth',
    };
  },
});

router.beforeEach((to, from, next) => {
  if (to.meta.aditional) {
    to.meta.layout = from.meta.layout
  }
  if (localStorage.getItem('typeUser') &&  to.meta.typeUser == '') {
    to.meta.typeUser = localStorage.getItem('typeUser')
  }
  to = render_layout(to, from)
  // console.log(to)
  // console.log("BEFORE")
  // console.log(from.meta)
  // console.log(to.meta)
  switch(to.fullPath) {
    case "/dashboard":
      if (to.meta.typeUser == "System" && to.meta.typeRoute) {
        console.log("USUARIO SYSTEM")
        next('/dashboard_' + to.meta.typeRoute)
      } else {
        next()
      }
      break;
    case "/401":
      next();
      break;
    default:
      if (to.meta.typeUser != "") {
        if (to.meta.aditional == true) {
          if (to.meta.typeUser == 'Portal') {
            to.meta.layout = 'default'
          } 
          if (to.meta.typeUser == 'System') {
            to.meta.layout = 'system'
          }           
        }
        next()
      } else {
        next('/401')
      }
  }
  // fetchProfileData();
});
export default router;

